import Vue from 'vue';
import gql from 'graphql-tag';

const shippingProvider = Vue.$session.get('selectedShippingProvider') || undefined;

export default {
    namespaced: true,
    state: {
        shippingCountries: {},
        shippingProviders: {},
        shippingPrices: null,
        selectedShippingProvider: shippingProvider,
        selectedShippingProviderName: null,
        lastShippingCountriesLoadTime: null,
        shippingProvidersLoaded: false,
    },
    getters: {
        getShippingPrices: state => state.shippingPrices,
    },
    mutations: {
        setShippingCountries(state, shippingCountries) {
            //Sort complete country list
            const favoriteCountries = [];
            const normalCountries = Object.values(Vue.$country.getCountries())
                .filter(country => {
                    if (country.isFavorite === true) {
                        favoriteCountries.push(country);
                    } else {
                        return true;
                    }
                })
                .sort((a, b) => {
                    return a.name === b.name ? 0 : a.name > b.name ? 1 : -1;
                });
            favoriteCountries.sort((a, b) => {
                return a.name === b.name ? 0 : a.name > b.name ? 1 : -1;
            });
            const allSortedCountries = [...favoriteCountries, ...normalCountries];

            //Sort shipping country list based on sorted complete country list
            const mapOrder = (array, order, key) => {
                array.sort((a, b) => {
                    let A = a[key],
                        B = b[key];

                    if (order.indexOf(A) > order.indexOf(B)) {
                        return 1;
                    } else {
                        return -1;
                    }
                });
                return array;
            };
            const sortedShippingCountries = Object.values(shippingCountries);
            mapOrder(
                sortedShippingCountries,
                allSortedCountries.map(p => p.id),
                'countryId',
            );

            state.shippingCountries = sortedShippingCountries;
        },
        setShippingProviders: (state, shippingProviders) => (state.shippingProviders = shippingProviders),
        setSelectedShippingProvider(state, value) {
            state.selectedShippingProvider = value;

            if (value && state.shippingProviders[value]) {
                state.selectedShippingProviderName = state.shippingProviders[value].title;
            } else {
                state.selectedShippingProviderName = null;
            }
            Vue.$session.set('selectedShippingProvider', state.selectedShippingProvider);
            Vue.$order.clearOrder();
        },
        setLastShippingCountriesLoadTime(state, value) {
            state.lastShippingCountriesLoadTime = value;
        },
        setShippingPrices(state, value) {
            state.shippingPrices = value;
        },
        setShippingProvidersLoaded: (state, value) => (state.shippingProvidersLoaded = value),
    },
    actions: {
        loadPossibleShippingCountries({ state, commit }) {
            if (state.lastShippingCountriesLoadTime === null || Vue.$basket.didBasketChanged(state)) {
                return Vue.$graphql
                    .query({
                        query: gql`
                        query getPossibleShippingCountries($basket: JSON!) {
                            getPossibleShippingCountries(basket: $basket) {
                                id
                                countryId
                                countryName
                                iso_2
                                shipping_types
                            }
                        }
                    `,
                        variables: {
                            basket: Vue.$basket.getConvertedLocalBasket(),
                        },
                        fetchPolicy: 'no-cache',
                    })
                    .then(r => r.data.getPossibleShippingCountries)
                    .then(result => {
                        commit('setShippingCountries', result);
                        commit('setLastShippingCountriesLoadTime', Date.now());
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }
        },
        selectedCountryIdChange({ state }, value) {
            if (Vue.$country.getCountryID() != value) {
                const country = Vue.$country.getCountryBy('id', value);
                Vue.$country.setCountry(country.iso_2);
                Vue.$basket.setCountryId(value);

                state.shippingCountries.some(shippingCountry => {
                    if (shippingCountry.countryId === country.id) {
                        if (shippingCountry.shipping_types[0]) {
                            Vue.$basket.addBasketOption({
                                key: 'shippingType',
                                value: shippingCountry.shipping_types[0].id
                            });
                        }
                        return true;
                    }
                    return false;
                })
            }
        },
        loadMerchantShippingPrices({ state, commit }) {
            if (Vue.$country.getCountryID() && state.shippingProvidersLoaded) {
                const result = {};
                if (undefined !== state.selectedShippingProvider) {
                    Vue.$graphql
                        .query({
                            query: gql`
                                query getMerchantShippingPrices(
                                    $basket: JSON!
                                    $countryId: Int!
                                    $currency: String!
                                    $shippingProviderId: Int
                                ) {
                                    getMerchantShippingPrices(
                                        basket: $basket
                                        countryId: $countryId
                                        currency: $currency
                                        shippingProviderId: $shippingProviderId
                                    ) {
                                        price
                                        company_department_id
                                    }
                                }
                            `,
                            variables: {
                                basket: Vue.$basket.getConvertedLocalBasket(),
                                countryId: parseInt(Vue.$country.getCountryID()),
                                currency: Vue.$currency.getSelected(),
                                shippingProviderId: state.selectedShippingProvider,
                            },
                            fetchPolicy: 'no-cache',
                        })
                        .then(r => r.data.getMerchantShippingPrices)
                        .then(merchantShippingPrices => {
                            merchantShippingPrices.forEach(merchantShippingPrice => {
                                result[merchantShippingPrice.company_department_id] = merchantShippingPrice.price;
                            });
                            commit('setShippingPrices', result);
                            Vue.$basket.setShippingPrices(result);
                        })
                        .catch(err => {
                            console.log(err);
                        });
                } else {
                    commit('setShippingPrices', result);
                    Vue.$basket.setShippingPrices(result);
                }
            }
        },
        loadShippingPricesProviders({ state, commit, dispatch }) {
            commit('setShippingProvidersLoaded', false);
            if (Vue.$country.getCountryID()) {
                Vue.$graphql
                    .query({
                        query: gql`
                            query getShippingPricesProviders($basket: JSON!, $countryId: Int!) {
                                getShippingPricesProviders(basket: $basket, countryId: $countryId) {
                                    id
                                    title
                                }
                            }
                        `,
                        variables: {
                            basket: Vue.$basket.getConvertedLocalBasket(),
                            countryId: parseInt(Vue.$country.getCountryID()),
                        },
                        fetchPolicy: 'no-cache',
                    })
                    .then(r => r.data.getShippingPricesProviders)
                    .then(providers => {
                        const shippingProviders = {};
                        for (const provider of providers) {
                            shippingProviders[provider.id] = provider;
                        }
                        commit('setShippingProviders', shippingProviders);

                        if (providers.length > 0) {
                            if (
                                !state.selectedShippingProvider ||
                                !Object.keys(state.shippingProviders).hasOwnProperty(state.selectedShippingProvider)
                            ) {
                                const [shippingProvider] = providers;
                                commit('setSelectedShippingProvider', shippingProvider.id);
                            }
                        } else {
                            commit('setSelectedShippingProvider', null);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        commit('setShippingProviders', null);
                    })
                    .then(() => {
                        commit('setShippingProvidersLoaded', true);
                        dispatch('loadMerchantShippingPrices');
                    });
            }
        },
    },
};
